import { render } from "./TeamingChip.vue?vue&type=template&id=70e26ff9&scoped=true"
import script from "./TeamingChip.vue?vue&type=script&lang=js"
export * from "./TeamingChip.vue?vue&type=script&lang=js"

import "./TeamingChip.vue?vue&type=style&index=0&id=70e26ff9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70e26ff9"

export default script